export const styles = theme => ({
  content: {
    display: 'block',
    paddingTop: theme.spacing.unit * 2
  },
  disabled: {
    opacity: 0.3,
    pointerEvents: 'none'
  }
})



// WEBPACK FOOTER //
// ./src/components/RouteInfo/styles.js